var map = {
	"./ny_01.jpg": 71746,
	"./ny_02.jpg": 97885,
	"./ny_03.jpg": 83293,
	"./ny_04.jpg": 49848,
	"./ny_05.jpg": 58686,
	"./ny_06.jpg": 38483,
	"./ny_07.jpg": 86223,
	"./ny_08.jpg": 41412,
	"./ny_09.jpg": 88572,
	"./ny_10.jpg": 13518,
	"./ny_11.jpg": 57721,
	"./ny_12.jpg": 23938,
	"./ny_13.jpg": 44179,
	"./ny_14.jpg": 41442,
	"./ny_15.jpg": 58351,
	"./ny_16.jpg": 64424,
	"./ny_17.jpg": 32131,
	"./ny_18.jpg": 6751,
	"./ny_19.jpg": 2891,
	"./ny_20.jpg": 93184,
	"./ny_21.jpg": 69744,
	"./ny_22.jpg": 7804,
	"./ny_23.jpg": 69634,
	"./ny_24.jpg": 96164,
	"./ny_25.jpg": 73877,
	"./ny_26.jpg": 57848,
	"./ny_27.jpg": 89006,
	"./ny_28.jpg": 53608,
	"./ny_29.jpg": 40199,
	"./ny_30.jpg": 42060,
	"./ny_31.jpg": 12405,
	"./ny_32.jpg": 77910,
	"./ny_33.jpg": 79793,
	"./ny_34.jpg": 83130,
	"./ny_35.jpg": 58738,
	"./ny_36.jpg": 19000,
	"./ny_original.jpg": 66751
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 69674;